import identityApiClient from "@libs/acp/services/identity/axiosInstance";
import privateIdentityApiClient from "@libs/acp/services/identity/privateAxiosInstance";

import type {
	IdentitySignInEmailConfirmationProps,
	IdentitySignInHandleDocumentProps,
	IdentitySignInHandleMFACodeProps,
	IdentitySignInProps,
	IdentitySignInUserEmailStatus,
	IdentitySimpleSignInProps,
} from "./types";

export const identitySignInHandleDocument = ({
	document,
	hasKBA,
  metadata,
}: IdentitySignInHandleDocumentProps & { hasKBA?: "control" | "variant" }) => {
	return identityApiClient.post(
		"/v2/public/auth/document",
		{ document, metadata },
		{
			headers: {
				"X-AB-Test": hasKBA,
			},
		},
	);
};

export const identitySignIn = ({ document, password }: IdentitySignInProps) => {
	return identityApiClient.post("/v2/public/auth/signin", {
		document,
		password,
	});
};

export const identitySimpleSignIn = ({
	document,
	birthdate,
	gRecaptchaResponse,
	gRecaptchaAction,
}: IdentitySimpleSignInProps) => {
	return identityApiClient.post("/v2/public/auth/signin/simplified", {
		document,
		birthdate,
		"g-recaptcha-action": gRecaptchaAction,
		"g-recaptcha-response": gRecaptchaResponse,
	});
};

export const identityEngageSignIn = (
	token: string,
	isCachedEngageSignin = "false",
	utm?: string,
	flow?: string | null,
) => {
	return identityApiClient.post(
		"/v2/engage/signin",
		{
			utm: utm,
			flow,
		},
		{
			headers: {
				Authorization: `Bearer ${token}`,
				"X-Cached-Engage-Signin": isCachedEngageSignin,
			},
		},
	);
};

export const identitySignInGenerateMFACode = ({
	document,
	type,
}: IdentitySignInHandleMFACodeProps) => {
	return identityApiClient.post(
		`/v2/public/auth/signin/contact/${type}/send-code`,
		{
			document,
		},
	);
};

export const identitySignInValidateMFACode = ({
	document,
	code,
	type,
}: IdentitySignInHandleMFACodeProps) => {
	return identityApiClient.post(
		`/v2/public/auth/signin/contact/${type}/validate-code`,
		{
			document,
			code,
		},
	);
};

export const identityRefreshToken = (refreshToken: string) => {
	return privateIdentityApiClient.post<{
		data: {
			access_token: string;
			refresh_token: string;
		};
	}>(
		"/v2/public/auth/refresh-token",
		{},
		{
			headers: {
				"Refresh-Token": refreshToken,
			},
		},
	);
};

export const identityEngageCustomerData = () => {
	return privateIdentityApiClient.get<IdentitySignInUserEmailStatus>(
		"/v2/app/email-status",
	);
};

export const identitySignInEmailConfirmation = ({
	birthDate,
	engageToken,
}: IdentitySignInEmailConfirmationProps) => {
	return identityApiClient.post(
		"/v2/engage/communication-update",
		{
			birthDate,
		},
		{
			headers: {
				Authorization: `Bearer ${engageToken}`,
			},
		},
	);
};
